module.exports = __webpack_public_path__ + "static/desk-94acdeffafb31127b27cb5eccc7dc888.svg";